// Modal.js
import React, { useState } from "react";
import "../../components/Modal.css";
import { useCreateFournisseurMutation } from "actions/fournisseurs/mutations";
// import { useDispatch } from "react-redux";
import { useFormContext } from "react-hook-form";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
//import {useGetFournisseurQuery} from "actions/fournisseurs/queries";
import { useGetCodesFournisseursQuery } from "actions/comptabilite/queries";
import Switch from "components/SwitchButton/Switch";
import GeneriqueModal from "components/GeneriqueModal";
import ButtonCancel from "components/buttons/ButtonCancel";
import ButtonGreen from "components/buttons/ButtonGreen";
import CustomSelectController from "components/CustomSelect/CustomSelect";
import useGetCurrentUser from "hooks/useGetCurrentUser";

const ModalFournisseur = ({
  isOpen,
  onClose,
  onDossierCreated,
  retour,
  refetch,
  refetchCodesTiers
}) => {
  const { clientID: dossier_id } = useParams();
  const navigate = useNavigate();
  const currentUser = useGetCurrentUser();
  

  const { data: codes = [] } = useGetCodesFournisseursQuery();

  console.log("Codes fournisseurs:", codes);
  console.log("Utilisateur courant:", currentUser);

  const [lettrage, setLettrage] = useState(false);

  // Déterminer si l'utilisateur est une entreprise
  const isEntreprise = currentUser?.status === "ENTREPRISE";

  // const dispatch = useDispatch();

  const [creationFournisseur, { isLoading }] = useCreateFournisseurMutation();
  /*const {data: getFournisseur, refetch} = useGetFournisseurQuery({
    dossier_id,
  });*/

  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = React.useRef(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setError,
  } = useFormContext();

  const [apiError, setApiError] = React.useState(null);

  const handleClose = () => {
    onClose();
  };

  const getErrorMessage = (error) => {
    if (!error) return "Une erreur est survenue";
    
    if (error.data && typeof error.data === 'object') {
      if (error.data.detail) return error.data.detail;
      
      const firstKey = Object.keys(error.data)[0];
      if (firstKey && Array.isArray(error.data[firstKey])) {
        return error.data[firstKey][0];
      }
      if (firstKey && typeof error.data[firstKey] === 'string') {
        return error.data[firstKey];
      }
    }
    
    return error.message || "Une erreur est survenue";
  };

  const refetchData = async () => {
    if (!refetch) return;
    try {
      await refetch();
    } catch (error) {
      // Ignorer les erreurs de refetch
    }
  };

  const onSubmit = async (data) => {
    if (isSubmittingRef.current || isLoading || isSubmitting) return;
    isSubmittingRef.current = true;
    setIsSubmitting(true);
    setApiError(null);
    
    try {
      // Gérer le compte_comptable (peut être un objet ou une string)
      let compteComptableValue = null;
      if (data.compte_comptable) {
        if (typeof data.compte_comptable === 'object' && data.compte_comptable.value) {
          compteComptableValue = data.compte_comptable.value.toString();
        } else if (typeof data.compte_comptable === 'string') {
          compteComptableValue = data.compte_comptable;
        }
      }
      
      // Nettoyer les champs : le backend Django attend des chaînes même vides pour telephone, email, adresse
      const cleanEmail = data.email && data.email.trim() ? data.email.trim() : '';
      const cleanTelephone = data.telephone && data.telephone.trim() ? data.telephone.trim() : '';
      const cleanAdresse = data.adresse && data.adresse.trim() ? data.adresse.trim() : '';

      // Convertir dossier_id en nombre si c'est une string (PrimaryKeyRelatedField attend un nombre)
      const dossierIdNum = typeof dossier_id === 'string' ? parseInt(dossier_id, 10) : dossier_id;
      
      // S'assurer que compte_comptable est une string (le backend fait .isdigit() dessus)
      const compteComptableStr = typeof compteComptableValue === 'number' 
        ? compteComptableValue.toString() 
        : String(compteComptableValue);
      
      const fournisseurData = {
        nom: data.nom?.trim() || '',
        dossier_id: dossierIdNum,
        lettrage: lettrage,
        compte_comptable: compteComptableStr,
        email: cleanEmail,
        telephone: cleanTelephone,
        adresse: cleanAdresse,
      };
      
      await creationFournisseur(fournisseurData).unwrap();
      toast.success("Création du fournisseur réussie !");
      reset();
      refetchData();
      if (refetchCodesTiers) {
        refetchCodesTiers();
      }
      onDossierCreated();
      if (retour) navigate(-1);
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setApiError(errorMessage);
      
      if (error.data && typeof error.data === 'object') {
        Object.keys(error.data).forEach((fieldName) => {
          const fieldError = error.data[fieldName];
          if (Array.isArray(fieldError)) {
            setError(fieldName, {
              type: "server",
              message: fieldError[0]
            });
          }
        });
      }
      
      toast.error(errorMessage);
    } finally {
      isSubmittingRef.current = false;
      setIsSubmitting(false);
    }
  };


  // Adapter les options en fonction du statut de l'utilisateur
  const options = codes?.map((code_fournisseur) => ({
    value: code_fournisseur.code,
    label: isEntreprise ? code_fournisseur.libelle : code_fournisseur.combine,
  }));

  return (
    <>
      <GeneriqueModal
        isOpen={isOpen}
        onClose={handleClose}
        title="Ajouter un fournisseur">
        <form
          className="fournisseur-form"
          autoComplete="off"
          onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <label htmlFor="nom" className="form-label">
              Prénom et nom<span style={{ color: "red" }}>(*)</span>
            </label>
            <input
              className="form-controll"
              type="text"
              id="nom"
              placeholder="Prénom et nom"
              {...register("nom", { required: "Nom obligatoire" })}
            />
            {errors.nom && (
              <div className="text-danger">{errors.nom.message}</div>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="telephone" className="form-label">
              Numéro de téléphone
            </label>
            <input
              className="form-controll"
              type="tel"
              id="telephone"
              placeholder="777777777 (optionnel)"
              {...register("telephone", { 
                maxLength: {
                  value: 9,
                  message: "Le numéro de téléphone ne doit pas dépasser 9 caractères"
                },
                validate: (value) => {
                  if (!value || value.trim() === '') return true; // Champ optionnel
                  if (value.length > 9) return "Le numéro de téléphone ne doit pas dépasser 9 caractères";
                  return true;
                }
              })}
            />
            {errors.telephone && (
              <div className="text-danger">{errors.telephone.message}</div>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="adresse" className="form-label">
              Adresse<span style={{ color: "red" }}>(*)</span>
            </label>
            <input
              className="form-controll"
              type="text"
              id="adresse"
              placeholder="Adresse"
              {...register("adresse")}
            />
            {errors.adresse && (
              <div className="text-danger">{errors.adresse.message}</div>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="email" className="form-label">
              E-mail
            </label>
            <input
              className="form-controll"
              type="email"
              id="email"
              placeholder="email@example.com (optionnel)"
              {...register("email", {
                validate: (value) => {
                  if (!value || value.trim() === '') return true; // Champ optionnel
                  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                  return emailRegex.test(value) || "Format d'email invalide";
                }
              })}
            />
            {errors.email && (
              <div className="text-danger">{errors.email.message}</div>
            )}
          </div>

          {/* Compte Comptable ou Type selon le statut */}
          <div className="form-group">
            <label htmlFor="compte_comptable" className="form-label">
              {isEntreprise ? "Type" : "Compte Comptable"}<span style={{ color: "red" }}>(*)</span>
            </label>
            <CustomSelectController
              control={control}
              name="compte_comptable"
              rules={{ required: isEntreprise ? "Type obligatoire" : "Compte comptable obligatoire" }}
              options={options || []}
              placeholder={isEntreprise ? "Sélectionner un type" : "Sélectionner un compte comptable"}
              isClearable
              formatCreateLabel={(inputValue) => `Créer "${inputValue}"`}
              onCreateOption={(inputValue) => {
                return { value: inputValue, label: inputValue };
              }}
            />
            {errors.compte_comptable && (
              <div className="text-danger">
                {errors.compte_comptable.message}
              </div>
            )}
          </div>

          {/* Lettrage Checkbox - Caché pour les entreprises */}
          {!isEntreprise && (
            <div className="form-group d-flex align-items-end gap-3">
              <label htmlFor="lettrage" className="form-label">
                Lettrage
              </label>
              <Switch
                isOn={lettrage}
                handleToggle={() => setLettrage(!lettrage)}
                colorOne="#068f7a"
                colorTwo="#ccc"
              />
            </div>
          )}

          {apiError && (
            <div
              style={{
                padding: "12px",
                marginBottom: "16px",
                backgroundColor: "#ffebee",
                border: "1px solid #ef5350",
                borderRadius: "4px",
                color: "#c62828",
                fontSize: "14px",
              }}
            >
              {apiError}
            </div>
          )}

          <div className="modal-footer">
            <ButtonCancel text={"Annuler"} onClick={onClose} />
            <ButtonGreen
              text={isLoading || isSubmitting ? "Enregistrement..." : "Enregistrer"}
              type={"submit"}
              loading={isLoading || isSubmitting}
              disabled={isLoading || isSubmitting}
            />
          </div>

        </form>
      </GeneriqueModal>
    </>
  );
};

export default ModalFournisseur;